const formValuesSchema = {
  assessment_type: '',
  gender: '',
  birthdate: { month: '', day: '', year: '' },
  weight: { value: '', measurement_unit: '' },
  height: { unit: 'cm', cm: '', feet: '', inch: '' },
  body_fat_percentage: {
    method: 'text',
    caliperMethod: 'jp7',
    chest: '',
    abdominal: '',
    thigh: '',
    subscapular: '',
    tricep: '',
    suprailiac: '',
    midaxillary: '',
    lower_back: '',
    calf: '',
    bicep: '',
    textFatPercentage: '',
    calculatedFatPercentage: ''
  },
  measurements: {
    chest: '',
    waist: '',
    hips: '',
    upper_leg: '',
    calf: '',
    upper_arm: ''
  },
  dowel_bodyweight_squat: {
    video: { url: '', size: 0 },
    rating_measurement_unit: '',
    dysfunction: {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false
    }
  },
  dowel_standing_shoulder_press: {
    video: { url: '', size: 0 },
    rating_measurement_unit: '',
    dysfunction: {
      0: false,
      1: false,
      2: false,
      3: false
    }
  },
  dowel_standing_hip_hinge: {
    video: { url: '', size: 0 },
    rating_measurement_unit: '',
    dysfunction: {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false
    }
  },
  db_front_foot_elevated_split_squat: {
    video: { url: '', size: 0 },
    rating_measurement_unit: '',
    dysfunction: {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false
    }
  },
  ng_shoulder_width_lat_pull_down: {
    video: { url: '', size: 0 },
    rating_measurement_unit: '',
    dysfunction: {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false
    }
  },
  progress_photos: {
    front: { url: '', size: 0 },
    side: { url: '', size: 0 },
    back: { url: '', size: 0 }
  }
};

export default formValuesSchema;
